import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { Checkbox, Form } from 'semantic-ui-react';

export default class StudentTable extends Component {
  static propTypes = {
    fetchData: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    loading: PropTypes.bool,
  };

  columns = [
    {
      Header: 'Student Id',
      accessor: 'Id',
      resizable: true,
      filterable: true,
    },
    {
      Header: 'Last Name',
      accessor: 'LastName',
      resizable: true,
      filterable: true,
    },
    {
      Header: 'First Name',
      accessor: 'FirstName',
      resizable: true,
      filterable: true,
    },
    {
      Header: 'Status',
      accessor: 'StatusCurrent',
      resizable: true,
      filterable: true,
    },
    {
      accessor: 'IdSeed',
      resizable: true,
      sortable: false,
      Cell: ({ original }) => {
        const { onChange, value } = this.props.input;
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={
                (value[0] === 'All' &&
                  !value.some(id => id === original.IdSeed)) ||
                (value[0] !== 'All' && value.some(id => id === original.IdSeed))
              }
              onChange={(e, data) => {
                var invert = value[0] === 'All';
                var selectedStudents = [...value].filter(
                  studentId => studentId !== original.IdSeed
                );

                if ((data.checked && !invert) || (!data.checked && invert)) {
                  selectedStudents.push(original.IdSeed);
                }

                onChange(selectedStudents);
              }}
            />
          </div>
        );
      },
      Header: () => {
        const { onChange, value } = this.props.input;
        return (
          <div style={{ textAlign: 'center' }}>
            <div>Selected</div>
            <Checkbox
              checked={value[0] === 'All' && value.length === 1}
              indeterminate={
                (value[0] === 'All' && value.length > 1) ||
                (value[0] !== 'All' && value.length > 0)
              }
              onChange={(e, data) => {
                onChange(data.checked ? ['All'] : []);
              }}
            />
          </div>
        );
      },
    },
  ];

  render() {
    const {
      meta: { touched, error },
    } = this.props;

    return (
      <Form.Field error={touched && error ? true : false}>
        <ReactTable
          manual
          defaultPageSize={10}
          data={this.props.data.result}
          loading={this.props.loading}
          onFetchData={(state, instance) => {
            this.props.fetchData(state);
          }}
          multiSort={false}
          showPageSizeOptions={true}
          pages={this.props.data.totalPages}
          columns={this.columns}
        />
        {touched && error ? (
          <span style={{ color: '#9F3A38' }}>{error}</span>
        ) : null}
      </Form.Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/letterhistoryreport/components/StudentTable.js